import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=4a878eaa&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=4a878eaa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a878eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a878eaa')) {
      api.createRecord('4a878eaa', component.options)
    } else {
      api.reload('4a878eaa', component.options)
    }
    module.hot.accept("./BasicInfo.vue?vue&type=template&id=4a878eaa&scoped=true", function () {
      api.rerender('4a878eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/form/BasicInfo.vue"
export default component.exports